var isString;

isString = require("./_helpers").isString;

module.exports = {
  _name: "$setAttribute",
  _v: 1,
  methods: {
    $setAttribute: function(el, name, val) {
      if (isString(el)) {
        val = name;
        name = el;
        el = this;
      }
      if ((val != null) && val !== false && (isString(val) || !isNaN(val))) {
        if (val === true) {
          el.setAttribute(name, "");
        } else {
          el.setAttribute(name, val);
        }
      } else {
        el.removeAttribute(name);
      }
      return {
        then: this.$nextTick
      };
    }
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/setAttribute.js
// module id = 17
// module chunks = 1